export default [
    //漏斗信息跟进表
    {
        path: '/loud/loud',
        name: '/loud/loud',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/loud.vue'),
    },
    //信息漏斗分析推荐表
    {
        path: '/loud/xinloud',
        name: '/loud/xinloud',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/loud_xin.vue'),
        meta: {
            title: '信息漏斗分析',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //区域新增交互漏斗
    {
        path: '/loud/quyuxinzeng',
        name: '/loud/quyuxinzeng',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/quyuxinzeng.vue'),
        meta: {
            title: '区域新增',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //区域产品漏斗
    {
        path: '/loud/quyuchanpin',
        name: '/loud/quyuchanpin',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/quyuchanpin.vue'),
        meta: {
            title: '区域链群',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //区域交互漏斗
    {
        path: '/loud/quyujiaohu',
        name: '/loud/quyujiaohu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/quyujiaohu.vue'),
        meta: {
            title: '区域交互',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //机会交互漏斗
    {
        path: '/loud/jihuijiaohu',
        name: '/loud/jihuijiaohu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/jihuijiaohu.vue'),
    },
    //产品交互漏斗
    {
        path: '/loud/chanpinjiaohu',
        name: '/loud/chanpinjiaohu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loud/chanpinjiaohu.vue'),
        meta: {
            title: '链群交互',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //日志管理
    {
        path: '/operation/operationLog',
        name: '/operation/operationLog',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/operation/operationLog.vue'),
    },
    //月度抢单
    {
        path: '/loud/monthQd',
        name: '/loud/monthQd',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/monthQd/monthQd.vue'),
        meta: {
            title: '月度抢单',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //月度抢单
    {
        path: '/loud/monthQdShow',
        name: '/loud/monthQdShow',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/monthQd/monthQdShow.vue'),
    },


        //抢单指标-到渠道
    {
        path: '/loud/channelIndex',
        component: () => import( '@/views/loud/xsptReport/channelIndex.vue'),
        meta: {
            title: '抢单指标-到渠道',
            isTabsPage: true,
            keepAlive:false
        }
    },
    //抢单指标-到链群
    {
        path: '/loud/lianqunIndex',
        component: () => import( '@/views/loud/xsptReport/lianqunIndex.vue'),
        meta: {
            title: '抢单指标-到链群',
            isTabsPage: true,
            keepAlive:false
        }
    },

]
